<template>
  <div class="wrap">
    <NavBar :title="$t('agent.title.agent')">
      <template #right>
        <van-icon name="chat-o" size="22" color="#0f172a" @click="rightClick" />
      </template>
    </NavBar>
    <div class="wrap_cont">
      <van-tabs v-model="tabActive" animated swipe-threshold="3" title-inactive-color="#7a8597"
        title-active-color="#31e2a5">
        <van-tab :title="$t(item)" v-for="item, index in tabList" :key="index"></van-tab>
      </van-tabs>
      <template v-if="tabActive == 0">
        <TabHome />
      </template>
      <template v-if="tabActive == 1">
        <AccountOpen />
      </template>
      <template v-if="tabActive == 2">
        <MyData />
      </template>
      <!-- <template v-if="tabActive == 3">
        <Performance />
      </template> -->
      <template v-if="tabActive == 3">
        <Commission />
      </template>
    </div>
    <!-- <CellGroup class="group">
      <Cell is-link class="cell_item" to="/inviteFriends">
        <template #title>
          <div class="left_wrap">
            <i class="iconfont icon-fenxianglianjie" style="color: #4eacf8"></i>
            <span>{{ $t("agent.title.share") }}</span>
          </div>
        </template>
      </Cell>
      <Cell is-link class="cell_item" to="/Cart">
        <template #title>
          <div class="left_wrap">
            <i class="iconfont icon-iconfontyouxihudong" style="color: #d9525e"></i>
            <span>{{ $t("agent.title.betInfo") }}</span>
          </div>
        </template>
      </Cell>
      <Cell is-link class="cell_item" to="/AccountData">
        <template #title>
          <div class="left_wrap">
            <i class="iconfont icon-yinhangqia1" style="color: #68d079"></i>
            <span>{{ $t("agent.title.paymentInfo") }}</span>
          </div>
        </template>
      </Cell>
      <Cell is-link class="cell_item" to="/AgentReport">
        <template #title>
          <div class="left_wrap">
            <i class="iconfont icon-baobiao4" style="color: #f5c142"></i>
            <span>{{ $t("agent.title.agent") }}</span>
          </div>
        </template>
      </Cell>
      <Cell is-link class="cell_item" to="/Commission">
        <template #title>
          <div class="left_wrap">
            <i class="iconfont icon-icon3" style="color: #579af8"></i>
            <span>{{ $t("agent.title.agentCommission") }}</span>
          </div>
        </template>
      </Cell>
    </CellGroup> -->
  </div>
</template>
<script>
import NavBar from "@/components/JNav";
import { CellGroup, Cell, Icon, Tab, Tabs } from "vant";
import TabHome from "./components/tab_home.vue"
import AccountOpen from "./components/account_open.vue"
import MyData from "./components/my_data.vue";
import Performance from "./components/performance.vue";
import Commission from "./components/commission.vue";
export default {
  components: {
    CellGroup,
    Cell,
    NavBar,
    [Icon.name]: Icon,
    [Tab.name]: Tab,
    [Tabs.name]: Tabs,
    TabHome,
    AccountOpen,
    MyData,
    Performance,
    Commission
  },
  data() {
    return {
      tabList: ['newTab.home', '直属开户', '我的资料', '我的佣金'], // '我的业绩'
      tabActive: 0
    };
  },
  methods: {
    rightClick() {
      this.$api.toService();
    }
  }
};
</script>


<style lang="less" scoped>
@import url("../../assets/iconfonts/iconfont.css");

@Color: var(--theme);
@comColor: var(--theme);
@wrapShadow: rgba(0, 0, 0, 0.12) 0px 4px 16px;
@wrapPadding: calc(12rem / 16);
@comRadius: 10px;
// @comBG: linear-gradient(#093958, #022c47);
@comBG: var(--bg1);

.wrap {
  min-height: calc(100vh - 50px - 18px);
  background: radial-gradient(circle at top right, rgba(24, 179, 141, .12), transparent 26%), radial-gradient(circle at left 25%, rgba(47, 110, 246, .1), transparent 22%), linear-gradient(180deg, #f7f9fc, #eef2f7);
  padding: 0 0 18px;

  .wrap_cont {
    padding: 10px 10px 0;

    :deep(.van-tabs__nav) {
      border-radius: 18px;
      background: #ffffffbf;

      .van-tab {
        font-weight: 600;
      }

      .van-tabs__line {
        background: #31e2a5;
      }
    }
  }

  .group {
    margin: 10px 10px 18px;
    border-radius: @comRadius;
    overflow: hidden;
    background: var(--bg);

    &::after {
      border: none;
    }

    .cell_item {
      // border-bottom: 1px solid #eee;
      background: @comBG;

      .left_wrap {
        display: flex;
        align-items: center;

        .iconfont {
          font-size: calc(26rem / 16);
          margin-right: calc(12rem / 16);
        }

        span {
          // color: var(--theme);
          color: var(--textColor);
        }
      }
    }
  }
}
</style>